import { css } from 'styled-components';
export default css(["font-family:", ";margin:0;padding:0;"], function (props) {
  var _props$theme;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.buttonFontFamily;
});